<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <div class="flex-search-details">
    <header>
      <div>
        <h1>{{ fileName }}</h1>
        <h2>Batch Search Results</h2>
      </div>
      <div>
        <ec-dropdown disappear-on-click>
          <v-btn slot="activator" class="rpt-btn" color="primary"
            >Reports<v-icon right>fa-caret-down</v-icon>
          </v-btn>

          <ul class="dropdown-wrapper dropdown-reports">
            <li><a :href="auditReportUri">Audit Report</a></li>
            <li v-if="resultTypes[0]">
              <a :href="exclusionReportsReportUri"
                >Exclusion Records Returned Report</a
              >
            </li>
          </ul>
        </ec-dropdown>
      </div>
    </header>

    <v-tabs height="24" v-model="activeTab">
      <v-tabs-slider color="orange" />

      <v-tab v-for="tab in activeTabs" :key="tab.name" :to="`#tab-${tab.name}`">
        {{ tab.displayName }}
      </v-tab>

      <v-tabs-items v-model="activeTab">
        <v-tab-item
          v-for="tab in activeTabs"
          :key="tab.name"
          :id="`tab-${tab.name}`"
        >
          <component :is="tab.name" :batch-id="batchId" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { API } from "@/common/constants"
import axios from "axios"
import FlexSearchDetailsExclusions from "@/components/FlexSearchDetails-Exclusions"
import FlexSearchDetailsNPI from "@/components/FlexSearchDetails-NPI"
import FlexSearchDetailsSSDMF from "@/components/FlexSearchDetails-SSDMF"
import EcDropdown from "@/components/Dropdown"

export default {
  name: "FlexSearchDetails",

  props: {
    batchId: {
      type: String,
      default: -1
    }
  },

  data: () => ({
    fileName: "",
    tabs: [
      FlexSearchDetailsExclusions,
      FlexSearchDetailsNPI,
      FlexSearchDetailsSSDMF
    ],
    resultTypes: []
  }),

  methods: {},

  computed: {
    activeTabs() {
      return this.tabs.filter((ele, idx) => this.resultTypes[idx])
    },
    activeTab() {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.resultTypes[i]) {
          return "tab-" + this.tabs[i].name
        }
      }
    },
    auditReportUri() {
      return API.FLEXBATCH_AUDIT_REPORT_BYID.replace(":batchId", this.batchId)
    },
    exclusionReportsReportUri() {
      return API.FLEXBATCH_EXCLUSION_RECORDS_REPORT_BYID.replace(
        ":batchId",
        this.batchId
      )
    }
  },
  created() {
    return axios
      .get(API.GET_BYID_ENDPOINT.replace(":batchId", this.batchId))
      .then(response => {
        this.fileName = response.data.fileName
        this.resultTypes = response.data.searchTypes
      })
  },
  components: {
    FlexSearchDetailsExclusions,
    FlexSearchDetailsNPI,
    FlexSearchDetailsSSDMF,
    EcDropdown
  }
}
</script>

<style lang="scss" scoped>
.flex-search-details {
  background-color: $color-white;
  height: 100%;
  header {
    background-color: $color-bg-gray;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 9.5rem;

    .rpt-btn {
      font-size: 1rem;
      font-weight: $heavy;
    }
    > div:first-child {
      margin-left: 3.75rem;

      h1 {
        font-size: 1.5rem;
        font-weight: $heavy;
      }
      h2 {
        @include normal-font;
      }
    }
    > div:nth-child(2) {
      margin-right: 1.5rem;
    }
    /deep/ .ec-dropdown-menu {
      right: 0;
      .dropdown-reports {
        li {
          padding: 0.5rem;
          &:hover {
            background-color: rgba(0, 0, 0, 0.1);
          }
          a {
            display: block;
          }
        }
      }
    }
  }

  /deep/ .v-tabs {
    .v-tabs__slider-wrapper {
      top: 0;
      z-index: 1;
    }

    .v-tabs__div {
      @include normal-font;
      margin-right: 0.375rem;
      border-radius: 0.125rem 0.125rem 0 0;
      overflow: hidden;
      width: 8rem;

      &:nth-child(2) {
        margin-left: 2rem;
      }
    }

    .v-tabs__item {
      background-color: #c5c5c5;
      opacity: 1;
      text-decoration: none;

      &.v-tabs__item--active {
        background-color: $color-white;
      }
    }

    .v-tabs__bar {
      background-color: $color-ec-light-gray;
    }

    .v-tabs__items {
      overflow: visible;
    }
  }

  .v-btn {
    text-transform: capitalize;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FlexSearchDetails.vue